import { useMutation } from "react-query";
import { post, downloadFile, OK_RESPONSE } from "../../../../http";
import { bulkExportUrl } from "./bulkExport.constants";
import { IBulkExportMutationPayload } from "./bulkExport.types";

export function useBulkExportMutation() {
  const { isLoading, isError, isSuccess, mutate } = useMutation((payload: IBulkExportMutationPayload) => downloadExportFile(payload));
  return { isBulkExportLoading: isLoading, isBulkExportError: isError, isBulkExportSuccess: isSuccess, bulkExport: mutate };
}

async function downloadExportFile(payload: IBulkExportMutationPayload) {
  try {
    const { formate, ...data } = payload;
    const url = `${bulkExportUrl}/${formate}`;
    const res = await post(url, data, {
      headers: {
        Accept: "*/*",
      },
    });

    if (res.status === OK_RESPONSE) {
      const blob = await res.blob();
      const filename = decodeURIComponent(
        res.headers
          .get("Content-Disposition")!
          .split("; ")
          .find((x) => x.includes("filename*=UTF-8''"))!
          .split("''")[1]
      );
      downloadFile(blob, filename);
    }
  } catch (err) {
    console.error(err);
  }
}
